var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { loadModuleRequest } from '../api/load-module';
import { requireModule } from './require-module';
var cachedScripts = new Map();
export var loadModule = function (_a) {
    var name = _a.name, staticURL = _a.staticURL, jsUrl = _a.jsUrl, fromCDN = _a.fromCDN, _b = _a.cdnData, _c = _b === void 0 ? {} : _b, APP_STATIC_NAMESPACE = _c.APP_STATIC_NAMESPACE, _d = _a.version, version = _d === void 0 ? '' : _d, _e = _a.externalPackages, externalPackages = _e === void 0 ? {} : _e;
    var endpoint = fromCDN ? jsUrl : "".concat(staticURL, "/").concat(jsUrl);
    var promise;
    if (cachedScripts.has(endpoint)) {
        promise = cachedScripts.get(endpoint);
    }
    else {
        promise = new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, data, error, errorText, source, extensionFn, module_1, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, loadModuleRequest(endpoint, fromCDN)];
                    case 1:
                        _a = (_b.sent()), data = _a.data, error = _a.error, errorText = _a.errorText;
                        if (error) {
                            throw new Error(errorText);
                        }
                        source = data
                            .replace(/pathToReplaceRuntimeEnvs/g, "/nsf/ui/".concat(APP_STATIC_NAMESPACE, "/umd/"))
                            .replace(/appVersion/g, version)
                            .replace(/publicPathForReplace/g, "".concat(staticURL, "/umd/"));
                        extensionFn = new Function('exports', 'require', 'module', source);
                        module_1 = {
                            exports: {},
                        };
                        extensionFn(module_1.exports, requireModule.bind(null, externalPackages), module_1);
                        resolve(module_1.exports);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.error('fetching the route script ended with an error', error_1);
                        // ToDo: need to research
                        reject(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        cachedScripts.set(endpoint, promise);
    }
    return promise
        .then(function (component) {
        if (component) {
            return component;
        }
        console.error("\"".concat(name, "\" was not created by \"").concat(endpoint, "\""));
        cachedScripts.delete(endpoint);
    })
        .catch(function () {
        cachedScripts.delete(endpoint);
    });
};
